import { storeAllEntities } from '@/helpers/store'
import * as api from '@/lti/api'

const getDefaultAdviseState = () => {
  return {
    advises: {},
    messages: {},
    mentors: {},
  }
}

export default {
  state: getDefaultAdviseState,

  mutations: {
    ADD_MESSAGE_TO_ADVISE (state, { adviseId, messageId }) {
      const advise = state.advises[adviseId]

      if (advise != null) {
        // We set MySubscription
        advise.messages.push(messageId)
      }
    },
  },
  actions: {
    getMentors ({ commit, state }) {
      return api.getMentors()
        .then(storeAllEntities(commit))
    },
    createThread ({ commit, state }, { data, subscribableId = null }) {
      return api.createThread(data)
        .then(storeAllEntities(commit))
        .then(resources => {
          if (subscribableId != null) {
            commit('ADD_ADVISE_TO_SUBSCRIBABLE', {
              subscribableId,
              adviseId: resources.primaryResources.map(s => s.id),
            })
          }
        })
    },
    addReaction ({ commit, state }, { adviseId, data }) {
      return api.addReaction(adviseId, data)
        .then(storeAllEntities(commit))
        .then(resources => {
          commit('ADD_MESSAGE_TO_ADVISE', {
            adviseId,
            messageId: resources.primaryResources.map(s => s.id),
          })
        })
    },
    completeAdvise ({ commit, state }, { adviseId }) {
      return api.completeAdvise(adviseId)
        .then(storeAllEntities(commit))
    },
  },
}
